import React, { useContext } from 'react';

import { ModernHotelContext } from 'app/context/HotelContext/ModernHotelContext';
import { ExtranetPackStatus } from 'app/typings/core/extranet/hotel/packs';

import styles from './ExperienceDiscount.module.scss';
import { PackCard } from './_components/PackCard';

type ExperienceDiscountProps = {
  expandedPackId: number | null;
  onPackToggle: (packId: number) => void;
};

export const ExperienceDiscount = ({
  expandedPackId,
  onPackToggle,
}: ExperienceDiscountProps) => {
  const { packsList } = useContext(ModernHotelContext);
  const overnightPublishedPacks = packsList.filter(
    (pack) => !pack.isDaytime && pack.status !== ExtranetPackStatus.HIDDEN
  );

  return (
    <div className={styles.wrapper}>
      <p className={styles.sectionTitle}>ACTIVITIES PRICING RULE</p>
      <div className={styles.packsList}>
        {overnightPublishedPacks.map((pack) => (
          <React.Fragment key={pack.id}>
            <PackCard
              pack={pack}
              isExpanded={expandedPackId === pack.id}
              onToggle={() => onPackToggle(pack.id)}
            />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
